import useOnce from './useOnce';

const useRemoveSearchParams = (keys: string[]) => {
  useOnce(() => {
    const url = new URL(window.location.href);
    keys.forEach((key) => url.searchParams.delete(key));
    // Bypasses the router on purpose: useLocation keeps the original params, analytics sees the cleaned URL
    window.history.replaceState(window.history.state, '', url);
  });
};

export default useRemoveSearchParams;
